export default __webpack_public_path__ + "static/media/select-none.91725133.svg";